var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.359375 6.45761C0.583509 6.12141 0.791633 5.7692 1.0638 5.44901C2.45663 3.75199 4.10561 2.32714 6.07479 1.31854C7.41959 0.64614 8.84444 0.197872 10.3653 0.0537862C13.2951 -0.218376 15.9527 0.550083 18.3861 2.18306C19.9711 3.23969 21.2839 4.56848 22.4205 6.05737C22.7087 6.42559 22.7087 6.82583 22.4205 7.19405C21.0918 8.92308 19.5548 10.412 17.6657 11.5326C16.0968 12.4452 14.4318 13.0375 12.6227 13.1976C9.98112 13.4538 7.54767 12.8454 5.27431 11.5006C3.40119 10.396 1.86427 8.90707 0.567499 7.19405C0.487451 7.08198 0.439423 6.9379 0.359375 6.80982C0.359375 6.69775 0.359375 6.56968 0.359375 6.45761ZM11.3419 1.95892C8.79641 2.00695 6.77921 4.16824 6.81123 6.7778C6.85926 9.32332 9.02055 11.3565 11.6461 11.3085C14.1756 11.2605 16.2248 9.08318 16.1768 6.48963C16.1288 3.94411 13.9675 1.9109 11.3419 1.95892Z",
    fill: "url(#paint0_linear_1394_547)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5019 4.11914C12.8628 4.11914 14.0155 5.23981 14.0155 6.58461C14.0155 8.00946 12.8788 9.16215 11.4859 9.14614C10.1091 9.14614 8.98845 8.00946 8.98845 6.63264C8.97244 5.25582 10.1091 4.11914 11.5019 4.11914Z",
    fill: "url(#paint1_linear_1394_547)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1394_547",
    x1: 0.360005,
    y1: 6.62652,
    x2: 22.6391,
    y2: 6.62652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1394_547",
    x1: 8.98842,
    y1: 6.63236,
    x2: 14.016,
    y2: 6.63236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.99988509e3b3e7b80334154890553858.svg";
export { ForwardRef as ReactComponent };